import { render } from "./time-warn.view.vue?vue&type=template&id=2e7b93ee&scoped=true&ts=true"
import script from "./time-warn.view.vue?vue&type=script&lang=ts"
export * from "./time-warn.view.vue?vue&type=script&lang=ts"

import "./time-warn.view.vue?vue&type=style&index=0&id=2e7b93ee&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7b93ee"]])

export default __exports__